/**
 * Footnote Linking
 * Links <sup> tags in content to footnote list items and vice versa
 * Uses data-smartscroll for smooth scrolling (handled by smart-scroll.js)
 */

class Footnotes {
  constructor() {
    this.init();
  }

  init() {
    const richText = document.querySelector('.article-content .rich-text');
    const footnotesList = document.querySelector('.article-content ol');
    
    if (!richText || !footnotesList) return;
    
    const firstRefs = {}; // Track first reference per footnote number
    
    // Process <sup> tags: wrap in links and track first occurrence
    richText.querySelectorAll('sup').forEach(sup => {
      const num = parseInt(sup.textContent.trim(), 10);
      if (!num) return;
      
      const link = document.createElement('a');
      link.href = `#footnote-${num}`;
      link.className = 'footnote-link';
      link.setAttribute('aria-label', `Footnote ${num}`);
      
      sup.parentNode.replaceChild(link, sup);
      link.appendChild(sup);
      
      // Track first reference for back link
      if (!firstRefs[num]) {
        firstRefs[num] = link;
        link.id = `footnote-ref-${num}`;
      }
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.footnotes = new Footnotes();
  });
} else {
  window.footnotes = new Footnotes();
}

export default Footnotes;

